import React, { Component } from "react";

class Circle extends Component {
  constructor(props) {
    super(props);

    this.state = {
      percent: this.props.params.start,
    };

    this.timer = null;
  }

  componentDidMount() {
    let percent =
      this.props.params.start -
      (this.props.params.start / 100) *
        (this.props.params.count / this.props.params.totalCount) *
        100;

    if (percent < 1 && percent > 0) {
      percent = 1;
    } else if (
      percent < this.props.params.start &&
      percent > this.props.params.start - 1
    ) {
      percent--;
    }

    this.timer = setTimeout(() => {
      if (isNaN(percent)) {
        percent = this.props.params.start;
      }

      this.setState({
        percent: percent,
      });
    }, 100);
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  render() {
    return (
      <svg
        className="progress-circle pr"
        height={this.props.params.height}
        width={this.props.params.width}
      >
        <circle
          cx={this.props.params.cx}
          cy={this.props.params.cy}
          r={this.props.params.radius}
          stroke={this.props.params.color}
          strokeWidth={this.props.params.strokeWidth}
          fill={this.props.params.fill}
          style={{
            strokeDasharray: this.props.params.start,
            strokeDashoffset: this.state.percent,
          }}
        />
        Sorry, your browser does not support inline SVG.
      </svg>
    );
  }
}

export default Circle;
